import { render, staticRenderFns } from "./examTimelineSetup.vue?vue&type=template&id=f59811a4&scoped=true&"
import script from "./examTimelineSetup.vue?vue&type=script&lang=js&"
export * from "./examTimelineSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59811a4",
  null
  
)

export default component.exports